import {
  useMarketingTheme,
  type MarketingThemeMode,
  type MarketingThemePreference,
} from '@/hooks/use-marketing-theme'
import { isLandingThemeToggleEnabled } from '@/landing/landing-theme-policy'

export type GuestSurfaceTheme = MarketingThemeMode
export type GuestSurfacePreference = MarketingThemePreference

/**
 * Session-scoped visitor theme for all logged-out surfaces (landing, login, register).
 * Never writes the app's localStorage preference.
 */
export function useGuestSurfaceTheme() {
  const themeToggleEnabled = isLandingThemeToggleEnabled()
  const { marketingTheme, marketingPreference, setMarketingTheme } =
    useMarketingTheme(themeToggleEnabled)
  return {
    guestTheme: marketingTheme as GuestSurfaceTheme,
    guestPreference: marketingPreference as GuestSurfacePreference,
    setGuestTheme: setMarketingTheme,
    themeToggleEnabled,
  }
}
